<template>
  <div v-if="isCenteredQrReloadSection">
    <FaceQRReloadSectionCenteredQR
      :on-tap-reload="onTapReload"
      :has-network-speed-issue="hasNetworkSpeedIssue"
      :qr-string="qrString"
    />
    <div class="spacer"></div>
    <Copyright class="copyright" />
  </div>
  <div v-else class="qr-slider-lower">
    <div class="qr-code-background" :style="ticketCardStyle">
      <div class="qr-code">
        <VueQrcode
          v-if="isValidQrString && qrString"
          :value="qrString"
          :options="{ width: 182 }"
        />
      </div>
    </div>
    <div class="spacer"></div>
    <Copyright class="copyright" />
  </div>
</template>

<script>
import passService from "@/services/pass";

export default {
  name: "FaceSliderQRWithBackgroundImage",
  props: {
    qrString: {
      type: String,
      required: true,
    },
    isValidQrString: {
      type: Boolean,
      default: null,
    },
    onTapReload: {
      type: Function,
      required: true,
    },
    isCenteredQR: {
      type: Boolean,
      default: false,
    },
    hasNetworkSpeedIssue: {
      type: Boolean,
      default: false,
    },
    isLoadingQRInfo: {
      type: Boolean,
      default: false,
    },
    backgroundImageUrl: {
      type: String,
      default: null,
    },
  },
  computed: {
    isCenteredQrReloadSection() {
      return passService.checkIsCenteredQrReloadSection({
        isCenteredQR: this.isCenteredQR,
        isLoadingQRInfo: this.isLoadingQRInfo,
        isValidQrString: this.isValidQrString,
        hasNetworkSpeedIssue: this.hasNetworkSpeedIssue,
      });
    },
    ticketCardStyle() {
      try {
        new URL(this.backgroundImageUrl);
      } catch {
        return {};
      }
      return { backgroundImage: `url(${this.backgroundImageUrl})` };
    },
  },
};
</script>

<style lang="scss" scoped>
.qr-slider-lower {
  flex: 1;
  width: 100%;
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-code-background {
  box-sizing: border-box;
  margin: 10px auto 24px;
  width: 300px;
  height: 300px;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.qr-code {
  background-color: #ffffff;
  width: 182px;
  height: 182px;
  padding-bottom: 8px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.spacer {
  height: 3.82vh;
}

.copyright {
  margin-bottom: 24px;
}
</style>
